module.exports = "/assets/data/28b9f10da3262de139ab254f41564de3-AB37.data.json";